import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';
import {getPaymentSessionId} from '../utils/helpers';

const getZepzPayinCards = async ({
    requestId, sessionId, params, query
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const paymentSessionId = getPaymentSessionId(params, query);
    const loggerProps = {
        requestId, sessionId, paymentSessionId
    };

    logger.info('Retrieving Zepz Payin cards', {
        eventId: eventIds['Retrieving Zepz Payin cards'],
        ...loggerProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}/cards`, config.zepzPayinIntegrator.url);

        const cardsResponse = await fetch(url.toString());

        throwOnResponseError(cardsResponse);

        const cards = await cardsResponse.json();

        logger.info('Retrieved Zepz Payin cards', {
            eventId: eventIds['Retrieved Zepz Payin cards'],
            ...loggerProps,
            payload: cards
        });

        return cards;
    } catch (e) {
        const error = new Error(`Error retrieving Zepz Payin cards: ${e.message}`);

        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Zepz Payin cards'],
            ...loggerProps
        });

        throw error;
    }
};

export default getZepzPayinCards;
